module.exports = __webpack_public_path__ + "static/day-to-day-79cc50dfc5f1a549dd673038a6e72a81.svg";